import { jsx as _jsx } from "react/jsx-runtime";
import { createFilledArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
const b = bemClassBuilder('v-showtime-list');
export const ShowtimeListSkeleton = observer(({ numberOfShowtimes }) => {
    const emptyArray = createFilledArray(undefined, numberOfShowtimes);
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx("ul", Object.assign({ className: b.element('list') }, { children: emptyArray.map((_, i) => (_jsx("li", Object.assign({ className: b.element('item') }, { children: _jsx("div", { className: b.element('button-wrapper', { ['skeleton']: true }) }) }), i))) })) })));
});
ShowtimeListSkeleton.displayName = 'ShowtimeListSkeleton';
